import {
  Table,
  Tooltip,
  notification,
  Spin,
  Select,
  Input,
  Button,
  Modal,
  Popconfirm,
  Tag,
} from "antd";
import * as React from "react";
import { get } from "lodash";
import {
  getAllCompanyPayTrn,
  deleteCompanyPayTrn,
} from "../../Graphs/CompanyPayTrn/companyPayTrn";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import CountUp from "react-countup";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import { Users, List, Gift, DollarSign, CreditCard, Flag } from "react-feather";
import _ from "lodash";
import { color } from "../../constant/comman";
import { DeleteOutlined } from "@ant-design/icons";
import { alertError } from "../../utils/alert";
import { dateFormat } from "../../utils/general";

var moment = require("moment");
const { Option } = Select;

class CompanyPayCoinTrn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      coinList: [],
      dataTotal: 0,
      isLoading: false,
      startIndex: 0,
      limitNumber: 5,
      pagination: {
        pageSize: 5,
        current: 1,
      },
      errors: {},
      price: 0,
      cardData: [],
      company_id: null,

      visible: false,
      closable: true,
    };
    this.handleTableChange = this.handleTableChange.bind(this);
  }

  componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }

    console.log("[CONSOLE LOG]", this.props.companyData);

    this.listUserCoinData(0, 5);
  }

  getLimitedUserCoin = async (pagination) => {
    console.log("tempCounter && counter --> ", this.tempCounter, this.counter);
    const start =
      pagination.current * pagination.pageSize - pagination.pageSize;
    const end = pagination.pageSize;

    this.setState(
      {
        isLoading: true,
        startIndex: start,
        limitNumber: end,
      },
      async () => {
        this.listUserCoinData(start, end);
      }
    );
  };

  listUserCoinData = async (start, end) => {
    try {
      const {
        companyData,
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let UserCoinData = await getAllCompanyPayTrn(
        authToken,
        start,
        end,
        companyData.id
      );
      console.log("!!!!!!!!!!!!UserCoinData", UserCoinData);

      if (UserCoinData.status == 200) {
        this.setState({
          isLoading: false,
          data: UserCoinData.data,
          dataTotal: UserCoinData.total,
        });
        console.log("!!!!!!!!!!!!UserCoinData", UserCoinData);
      } else if (UserCoinData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      } else {
        throw UserCoinData && UserCoinData.message
          ? UserCoinData.message
          : "Error";
      }
    } catch (e) {
      alertError('Company',e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleTableChange(pagination, filters) {
    console.log("outer onchange iusers", pagination);
    this.setState(
      {
        pagination,
      },
      () => this.getLimitedUserCoin(pagination)
    );
  }

  
  onChangeCoin = (value) => {
    this.setState({
      coin: value,
    });
  };

  onBlur = () => {
    console.log("blur");
  };

  onFocus = () => {
    console.log("focus");
  };

  onSearch = (val) => {
    console.log("search:", val);
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.hide();
  };

  show() {
    this.setState({
      visible: true,
    });
  }

  hide() {
    this.setState({
      visible: false,
    });
    this.props.onClose();
  }

  counter = 0;
  tempCounter = 0;
  columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      fixed: true,
      render: (text, item, index) => {
        return (
          <div>
            <span>{++index + this.tempCounter}</span>
          </div>
        );
      },
    },
    {
      title: "Coin",
      key: "coin",
      render: (text, item, index) => {
        console.log("coin record --> ", item);
        return (
          <div>
            <div
              style={{
                alignItems: "center",
                display: "inline-block",
                width: "100%",
              }}
            >
              <div flexDirection="column">
                <strong>
                  {" "}
                    <div>
                      {item.coin && item.coin.name ? item.coin.name : "-"}
                    </div>
                </strong>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Type",
      key: "Type",
      render: (text, item, index) => {
        console.log("coin record --> ", item);
        return (
          <div>
            <div
              style={{
                alignItems: "center",
                display: "inline-block",
                width: "100%",
              }}
            >
              <div flexDirection="column">
                <strong>
                  {" "}
                    <div>
                      {item.type ? (
                        <Tag
                          color={item.type == "COMPLETED" ? "green" : "red"}
                          key={"loser"}
                        >
                          {item.type.toUpperCase()}
                        </Tag>
                      ) : (
                        "-"
                      )}
                    </div>
                </strong>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Price",
      key: "Price",
      render: (text, item, index) => {
        console.log("user record --> ", item);
        return (
          <div>
            <div
              style={{
                alignItems: "center",
                display: "inline-block",
                width: "100%",
              }}
            >
              <div flexDirection="column">
                <strong>
                  {" "}
                    <div>{item.price !== null ? item.price : "-"}</div>
                </strong>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Date",
      key: "CreatedAt",
      render: (text, item, index) => {
        console.log("user record --> ", item);
        return (
          <div>
            <div
              style={{
                alignItems: "center",
                display: "inline-block",
                width: "100%",
              }}
            >
              <div flexDirection="column">
                <strong>
                  {" "}
                    <div>
                      {item.createdAt !== null
                        ? dateFormat(item.createdAt)
                        : "-"}
                    </div>
                </strong>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Actions",
      key: "action",
      render: (text, item, index) => {
        return (
          <div style={{ display: "inline-block", width: "100%" }}>
            <div mr="5px" style={{ float: "left" }}>
              <Tooltip placement="bottom" title="Delete">
                <Popconfirm
                  onConfirm={this.deleteCompanyPayTrn.bind(this, item)}
                  title="Are you sure you want to delete this paid transaction ?"
                >
                  <Button shape="circle" icon={<DeleteOutlined />} />
                </Popconfirm>
              </Tooltip>
            </div>
          </div>
        );
      },
    },
  ];

  async deleteCompanyPayTrn(item) {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        companyData,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let deleteData = await deleteCompanyPayTrn(
        authToken,
        startIndex,
        limitNumber,
        item.id,
        companyData.id
      );

      if (deleteData.status == 200) {
        notification["success"]({
          message: "Delete Paid Transaction",
          description: "Successfully deleted",
        });

        this.setState({
          isLoading: false,
          data: deleteData.data,
          dataTotal: deleteData.total,
        });
        console.log("!!!!!!!!!!!!deleteData", deleteData);
      } else if (deleteData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      } else {
        throw deleteData && deleteData.message ? deleteData.message : "Error";
      }
    } catch (e) {
      alertError('Company',e);
      
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  render() {
    const { isLoading, data, dataTotal } = this.state;

    return (
      <Modal
        width="600px"
        closable={this.state.closable}
        open={this.state.visible}
        title="Paid Transactions"
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={null}
        destroyOnClose={true}
      >
        {isLoading ? (
          <div style={{ marginLeft: "20px" }}>
            <Spin size="large" style={{ margin: "0 auto", width: "100%" }} />
          </div>
        ) : (
          <React.Fragment>
            <div style={{ "overflow-x": "auto" }}>
              <Table
                loading={this.state.isLoading}
                rowKey={(record) => record._id}
                columns={this.columns}
                size={"small"}
                // dataSource={this.state.data}
                dataSource={data}
                pagination={{
                  total: dataTotal,
                  showSizeChanger: true,
                  pageSize: this.state.pagination.pageSize,
                  current: this.state.pagination.current,
                  pageSizeOptions: ["1", "10", "25", "50", "100"],
                  onChange: (e) => {
                    console.log("onChanges pagination");
                    // e - 1
                    //   ? (this.counter = this.tempCounter =
                    //       (e - 1) * this.state.pagination.pageSize)
                    //   : ((this.counter = 0), (this.tempCounter = 0));
                    if (e - 1) {
                      this.counter = this.tempCounter =
                        (e - 1) * this.state.pagination.pageSize;
                      return;
                    }

                    this.counter = 0;
                    this.tempCounter = 0;
                  },
                }}
                onChange={this.handleTableChange}
              />
            </div>
          </React.Fragment>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  listUserCoinDataData: state.user_coin.listUserCoinData,
  listUserCoinDataTotal: state.user_coin.listUserCoinDataTotal,
  searchLoader: state.auth.searchLoader,
  searchText: state.auth.searchText,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setListUserCoinDataData: (listUserCoinData) => {
      dispatch({
        type: "SET_LIST_USER_COIN_DATA",
        listUserCoinData: listUserCoinData,
      });
    },
    setListUserCoinDataTotal: (listUserCoinDataTotal) => {
      dispatch({
        type: "SET_LIST_USER_COIN_DATA_TOTAL",
        listUserCoinDataTotal: listUserCoinDataTotal,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CompanyPayCoinTrn));
